__turbopack_context__.v({
  "quickTaskSubRowForm": "-tZonW_quickTaskSubRowForm",
  "quickTaskSubRowForm__row": "-tZonW_quickTaskSubRowForm__row",
  "quickTaskSubRowForm__rowTwo": "-tZonW_quickTaskSubRowForm__rowTwo",
  "quickTaskSubRowForm__status": "-tZonW_quickTaskSubRowForm__status",
});
